import React from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';

type TProps = {
    html: string;
};

const Colors = { bgPrimary: 'white' };
const Padding = { smWrapperPad: '10px' };
const Misc = { maxWidth: '100%' };

const Container = styled.div`
    overflow: hidden;
    background-color: ${Colors.bgPrimary};
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
`;

const Wrapper = styled.div`
    padding: 0 ${Padding.smWrapperPad};
    box-sizing: border-box;
    max-width: ${Misc.maxWidth};
    margin: 0 auto;
`;

const htmlTemplate = ({ html }: TProps): JSX.Element => (
    <Container>
        <Wrapper>{parse(html)}</Wrapper>
    </Container>
);

export default htmlTemplate;
